import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";

import {getBigDataApiPath} from "../../../../../utils/get_big_data_api_path";
import prepare_headers from "../../../store/prepare_headers";

export const userComApi = createApi({
    reducerPath: "userComApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${getBigDataApiPath()}user-com/`,
        prepareHeaders: prepare_headers,
        credentials: "include"
    }),
    tagTypes: ["UserCom"],
    endpoints: () => ({})
});
